import { FC, memo } from 'react';

import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';

import { TEXTS } from './texts';

import styles from './VideoPricePlan.module.scss';

interface VideoPriceInfoProps {
  withRequestText?: boolean;
}

export const VideoPriceInfo: FC<VideoPriceInfoProps> = memo(({ withRequestText = true }) => (
  <Info
    type={InfoTypes.INFO}
    className={styles.hintInfo}>
    <div>{TEXTS.VIDEO_PRICE_INFO_DESCRIPTION_1}</div>
    {withRequestText && <div>{TEXTS.VIDEO_PRICE_INFO_DESCRIPTION_2}</div>}
  </Info>
));
